<template>
  <div
    class="custom-coupon-page"
    :class="{
      'has-dock-promo':
        page.floatAd === 1 && page.enableAd === 1 && adList.length && !adClosed
    }"
  >
    <div v-if="bootLoading" class="page-boot">加载中…</div>

    <template v-else-if="bootError">
      <div class="page-boot page-boot--err">{{ bootError }}</div>
    </template>

    <template v-else>
      <!-- 与 Coupon.vue 一致：底层背景图 + 上层 .wrap 表单（comCouRecStyle .wrap padding-top） -->
      <div
        class="coupon custom-coupon-layer"
        :class="{ 'custom-coupon-layer--banner': !!page.bannerImage }"
        :style="bannerLayerStyle"
      >
        <div class="wrap">
          <div class="form">
            <div class="form-content">
              <van-form ref="form" @submit="subSuccess">
                <ul class="form-ul">
                  <li>
                    <van-field
                      v-model="form.code"
                      placeholder="请输入兑换码"
                      :rules="rules.code"
                      name="pattern"
                      :maxlength="16"
                      label="兑换码："
                      @blur="redeemChange"
                    />
                  </li>
                  <li>
                    <van-field
                      v-model="form.phone"
                      placeholder="请输入手机号"
                      :maxlength="11"
                      :rules="rules.phone"
                      label="手机号："
                      type="tel"
                      :disabled="phoneInputDisable"
                    />
                  </li>
                  <li class="tow-para">
                    <van-field
                      v-model="form.captcha"
                      placeholder="请输入验证码"
                      :maxlength="6"
                      :rules="rules.captcha"
                      label="验证码："
                      type="number"
                    />
                    <div
                      :class="
                        subBtnDisable
                          ? 'btn is-disable'
                          : btn.disable
                          ? 'btn is-disable'
                          : 'btn'
                      "
                      @click="getCode"
                    >
                      {{
                        subBtnDisable
                          ? '获取验证码'
                          : btn.disable
                          ? `${btn.num}s`
                          : '获取验证码'
                      }}
                    </div>
                  </li>
                </ul>
              </van-form>
            </div>
            <div
              :class="subBtnDisable ? 'btn-sub is-disable' : 'btn-sub'"
              @click="submit"
            >
              立即兑换
            </div>
          </div>

          <div class="rule">
            <h2><span>兑换规则</span></h2>
            <div
              v-if="page.exchangeRules"
              class="rule-html"
              v-html="page.exchangeRules"
            />
            <div v-else class="rule-empty">暂无规则说明</div>
          </div>

          <a class="beian" href="https://beian.miit.gov.cn/"
            >闽ICP备14019793号-8</a
          >
        </div>

        <div
          v-if="page.enableAd === 1 && adList.length && !adClosed"
          class="promo-strip"
          :class="{ 'promo-strip--dock': page.floatAd === 1 }"
        >
          <button
            type="button"
            class="promo-strip__close"
            aria-label="关闭"
            @click.stop="closeAd"
          >
            <img class="promo-strip__close-icon" :src="closeGrayImg" alt="" />
          </button>
          <van-swipe :autoplay="4000" indicator-color="#4086FF">
            <van-swipe-item v-for="(ad, i) in adList" :key="i">
              <div class="promo-strip__slide" @click="onAdClick(ad)">
                <img class="promo-strip__img" :src="ad.adImage" alt="" />
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </template>

    <van-dialog
      v-model="dialog.show"
      :showConfirmButton="false"
      class="cus-dialog"
    >
      <h3 class="title">温馨提示！</h3>
      <div class="msg">
        <p v-html="dialog.msg"></p>
        <ul
          v-if="
            dialog.ulMsgShow &&
              dialog.redeCodeStatus == 2 &&
              dialog.gcAttribute == 3
          "
        >
          <li>
            <span>充值商品：</span>
            <em>{{ dialog.goodsName }}</em>
          </li>
          <li>
            <span>充值账号：</span>
            <em>{{ dialog.account }}</em>
          </li>
          <li>
            <span>充值时间：</span>
            <em>{{ common.formatDate(dialog.rechargeTime, '{y}-{m}-{d}') }}</em>
          </li>
        </ul>
        <ul
          v-if="
            dialog.ulMsgShow &&
              dialog.redeCodeStatus === 2 &&
              dialog.gcAttribute != 3
          "
        >
          <li>
            <span>兑换商品：</span>
            <em>{{ dialog.goodsName }}</em>
          </li>
          <li>
            <span>手机号码：</span>
            <em>{{ dialog.account }}</em>
          </li>
          <li>
            <span>兑换时间：</span>
            <em>{{ common.formatDate(dialog.excTime, '{y}-{m}-{d}') }}</em>
          </li>
        </ul>
        <ul v-if="dialog.ulMsgShow && dialog.redeCodeStatus === 3">
          <li>
            <span>过期时间：</span>
            <em>{{ common.formatDate(dialog.expireTime, '{y}-{m}-{d}') }}</em>
          </li>
        </ul>
      </div>
      <div class="confirm" @click="dialogSure">确认</div>
    </van-dialog>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import {
  checkCode,
  getVerifyCode,
  checkPhone,
  getExchangePageDetail
} from '@/api'
import closeGrayImg from '@/assets/img/close_gray.png'

export default {
  name: 'CustomCoupon',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data() {
    const phoneVal = val => /^1\d{10}$/.test(val)
    return {
      bootLoading: true,
      bootError: '',
      page: {
        id: null,
        linkType: 1,
        linkName: '',
        bannerImage: '',
        exchangeRules: '',
        enableAd: 0,
        floatAd: 0,
        ads: []
      },
      form: {
        code: this.$route.query.code || undefined,
        phone: '',
        captcha: '',
        id: ''
      },
      rules: {
        code: [{ required: true, message: '请输入兑换码' }],
        phone: [{ validator: phoneVal, message: '请输入正确手机号' }],
        captcha: [{ required: true, message: '请输入验证码' }]
      },
      btn: {
        disable: false,
        timer: null,
        num: 60
      },
      dialog: {
        show: false,
        msg: '',
        ulMsgShow: false
      },
      subBtnDisable: true,
      phoneInputDisable: false,
      adClosed: false,
      closeGrayImg
    }
  },
  computed: {
    adList() {
      const ads = this.page.ads
      return Array.isArray(ads) ? ads.filter(a => a && a.adImage) : []
    },
    /** 配置 banner 作为底层背景（设计 750×634），无图时用 .coupon 默认底图 */
    bannerLayerStyle() {
      const url = this.page.bannerImage
      if (!url) {
        return {}
      }
      return {
        backgroundImage: `url("${url
          .replace(/\\/g, '/')
          .replace(/"/g, '%22')}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',
        backgroundSize: '100%',
        backgroundColor: '#eef0f4'
      }
    }
  },
  async mounted() {
    await this.loadPageConfig()
    if (this.$route.query.code) {
      this.CheckCode()
    }
  },
  beforeDestroy() {
    if (this.btn.timer) {
      clearInterval(this.btn.timer)
      this.btn.timer = null
    }
  },
  methods: {
    async loadPageConfig() {
      // 路由上的 view 即兑换页配置 id，与管理端 getDetail/{id} 一致
      const pageId = this.$route.query.view
      if (pageId == null || pageId === '') {
        this.bootLoading = false
        this.bootError = '链接缺少页面参数 view，无法加载配置'
        return
      }
      this.bootLoading = true
      this.bootError = ''
      try {
        const res = await getExchangePageDetail(pageId)
        if (res.code === 0 && res.data) {
          const d = res.data
          if (d.linkType != null && Number(d.linkType) !== 1) {
            this.bootError = '当前页面配置不是卡券兑换类型'
            this.bootLoading = false
            return
          }
          this.page = {
            id: d.id,
            linkType: d.linkType != null ? Number(d.linkType) : 1,
            linkName: d.linkName || '',
            bannerImage: d.bannerImage || '',
            exchangeRules: d.exchangeRules || '',
            enableAd: d.enableAd != null ? Number(d.enableAd) : 0,
            floatAd: d.floatAd != null ? Number(d.floatAd) : 0,
            ads: Array.isArray(d.ads) ? d.ads : []
          }
          document.title = this.page.linkName || document.title
        } else {
          this.bootError = res.message || '页面配置加载失败'
        }
      } catch (e) {
        this.bootError = '页面配置加载失败'
      } finally {
        this.bootLoading = false
      }
    },
    initForm() {
      this.form.phone = ''
      this.form.id = ''
      this.form.captcha = ''
    },
    CheckCode() {
      this.subBtnDisable = true
      const obj = {
        code: this.form.code,
        redeemCodePageType: 0
      }
      checkCode(obj).then(res => {
        if (res.code === 0) {
          const data = res.data
          if (data.routeFlag === 0) {
            this.phoneInputDisable = false
            this.form.id = data.id
            this.subBtnDisable = false
          } else if (data.routeFlag === 2) {
            this.initForm()
            this.dialog.msg = res.message
            for (const k in data) {
              this.dialog[k] = data[k]
            }
            this.dialog.show = true
            this.dialog.ulMsgShow = true
          } else {
            this.initForm()
            this.dialog.msg = '兑换类型不匹配，无法兑换！'
            this.dialog.show = true
          }
        } else {
          this.initForm()
          this.phoneInputDisable = false
          this.dialog.show = true
          if (res.data && res.data.checkRedeemCodeErrorCode) {
            switch (res.data.checkRedeemCodeErrorCode.code) {
              case -1:
                this.dialog.msg = '兑换码不存在'
                break
              case 1:
                this.dialog.msg = '该兑换码在兑换中'
                break
              case 2:
                this.dialog.msg = '该兑换码正在售后中，无法兑换！'
                break
              case 3:
                this.dialog.msg = '该兑换码已退款退券，无法兑换！'
                break
              case 4:
                this.dialog.msg = '该兑换码已冻结，无法兑换！'
                break
              case 5:
                this.dialog.msg = '该兑换码已使用'
                break
              case 6:
                this.dialog.msg = '兑换时间已过期'
                break
              case 7:
                this.dialog.msg = `兑换时间未开始，有效兑换时间：<br>${this.common.formatDate(
                  res.data.effectiveStartTime,
                  '{y}-{m}-{d}'
                )}~${this.common.formatDate(
                  res.data.effectiveEndTime,
                  '{y}-{m}-{d}'
                )}`
                break
              case 8:
                this.dialog.msg = '兑换类型不匹配'
                break
              case 9:
                this.dialog.msg = '兑换页面类型不匹配'
                break
              case 10:
                this.dialog.msg = '兑换手机号码信息不存在'
                break
              case 11:
                this.dialog.msg = '此兑换码已激活'
                break
              default:
                this.dialog.msg = res.message
                break
            }
          } else {
            this.dialog.msg = res.message
          }
        }
      })
    },
    redeemChange() {
      if (this.form.code) {
        this.CheckCode()
      }
    },
    submit() {
      if (!this.subBtnDisable) {
        this.$refs.form.submit()
      }
    },
    subSuccess() {
      const { id, phone, captcha, code } = this.form
      const obj = {
        code: captcha,
        id,
        phone,
        redeemCode: code
      }
      checkPhone(obj).then(res => {
        this.dialog.msg = res.message
        this.dialog.show = true
      })
    },
    getCode() {
      if (!this.btn.disable && !this.subBtnDisable) {
        this.$refs.form.validate('pattern').then(() => {
          const obj = {
            id: this.form.id,
            phone: this.form.phone
          }
          getVerifyCode(obj).then(res => {
            if (res.code === 0) {
              this.btn.num = 60
              this.btn.disable = true
              this.btn.timer = setInterval(() => {
                this.btn.num--
                if (this.btn.num <= 0) {
                  this.btn.disable = false
                  clearInterval(this.btn.timer)
                  this.btn.timer = null
                }
              }, 1000)
            } else {
              this.$toast(res.message)
            }
          })
        })
      }
    },
    dialogSure() {
      this.dialog.show = false
      setTimeout(() => {
        this.dialog.ulMsgShow = false
      }, 200)
    },
    closeAd() {
      this.adClosed = true
    },
    onAdClick(ad) {
      if (!ad) {
        return
      }
      if (ad.jumpType === 1 && ad.h5Url) {
        window.location.href = ad.h5Url
      } else if (ad.jumpType === 2) {
        // 配置了明文 Scheme 的小程序才可以跳转
        // 开发者无需调用平台接口，在「MP平台 - 左下角账号 - 账号设置 - 基本设置 - 隐私与安全 -
        // 明文Scheme拉起此小程序」声明后，可自行根据如下格式拼接appid和path等参数，作为明文 URL Scheme 链接。
        const path = `weixin://dl/business/?appid=${ad.appId}&path=${ad.jumpPath}`
        window.location.href = path
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/style/comCouRecStyle.less';

.custom-coupon-page {
  min-height: 100vh;
  background: #eef0f4;
  padding-bottom: env(safe-area-inset-bottom);
  /* 底部固定推广条时由子层预留空间，与 .promo-strip--dock 高度一致 */
  --dock-promo-offset: 0px;
}
.custom-coupon-page.has-dock-promo {
  /* 与 .promo-strip--dock 可视高度一致：图 170 + 条内下边距 24 + 安全区；轮播指示器叠在图内 */
  --dock-promo-offset: calc(170px + 24px + env(safe-area-inset-bottom));
}

.page-boot {
  padding: 80px 30px;
  text-align: center;
  font-size: 28px;
  color: #7a7a7a;
}
.page-boot--err {
  color: #ee0a24;
}

/* 与 Coupon 一致：整页底层背景，.wrap 在 comCouRecStyle 里已做 padding-top 叠在图上 */
.custom-coupon-layer {
  min-height: 100vh;
  box-sizing: border-box;
  /* 非悬浮：0；悬浮广告：与底部 fixed 条同高，避免备案/规则被挡住 */
  padding-bottom: var(--dock-promo-offset, 0px);
}

.rule-html {
  color: #7f7f7f;
  font-size: 26px;
  line-height: 1.8;
  word-break: break-word;
}
.rule-html /deep/ img {
  max-width: 100%;
  height: auto;
}
.rule-empty {
  color: #b1bac9;
  font-size: 26px;
}

.promo-strip {
  position: relative;
  max-width: 750px;
  box-sizing: border-box;
}
.promo-strip__close {
  position: absolute;
  top: -50px;
  right: 10px;
  z-index: 101;
  width: 50px;
  height: 50px;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
}
.promo-strip__close-icon {
  width: 28px;
  height: 28px;
  display: block;
  pointer-events: none;
}
.promo-strip--dock {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  z-index: 100;
  box-sizing: border-box;
}
.promo-strip__slide {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.promo-strip__img {
  width: 100%;
  max-width: 750px;
  height: 170px;
  object-fit: cover;
  display: block;
}

.beian {
  display: block;
  text-align: center;
  padding: 20px 0 40px;
}
</style>
